import styled from 'styled-components';

import { Icon } from 'components/Icon';
import { Tooltip } from 'components/Tooltip';

const Notice = styled.div`
  display: inline-flex;
  gap: 12px;
  align-items: center;
  font-size: 16px;
  padding: 0 0.5em;
  background-color: #f5edff;
  border-radius: 8px;
  color: #645694;
  height: 38px;
  line-height: 0;
`;

export function CreditCardSecureNotice() {
  return (
    <Notice>
      <Icon size={18} initialColorName="elementGrey" name="lock-filled" />

      <span>{getText('Your payment is secure')}</span>

      <Tooltip>
        {getText(
          'Your credit card information will be securely stored by our payment provider Stripe in conjunction with your individual Idealist account. Idealist staff will not be able to see your credit card information, and no other administrator at your organization will be able to see or use your credit card.',
        )}
      </Tooltip>
    </Notice>
  );
}
